import { DataService } from '../dataService';

export const chapterSummeryService = {
  create: async (data) => {
    try {
      const response = await DataService.post('/chapter-summery', data);
      return response;
    } catch (error) {
      throw error;
    }
  },
  get: async ({ book_id, slug, is_header, is_clone, is_header_two }) => {
    try {
      const response = await DataService.get(
        `/chapter-summery/${book_id}/${slug}?is_header=${is_header}&is_clone=${is_clone}&is_header_two=${is_header_two}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      const response = await DataService.delete(`/chapter-summery/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },
};
